export const UGC_PLATFORMS = [
  'DAILYBREAK',
  'DEMO',
  'EMBED',
  'FACEBOOK'
];

export const UgcStatusOptions = [
    {
        key: "Approved",
        value: "APPROVED",
        text: "Approved",
    },
    {
        key: "Rejected",
        value: "REJECTED",
        text: "Rejected",
    },
    {
        key: "Pending",
        value: "NEW",
        text: "Pending",
    }
];

export const ReceiptProcessingStatusOptions = [
    {
        key: "Approved",
        value: "APPROVED",
        text: "Approved",
    },
    {
        key: "Rejected",
        value: "REJECTED",
        text: "Rejected",
    },
    {
        key: "Pending",
        value: "PENDING",
        text: "Pending",
    }
];



// WEBPACK FOOTER //
// ./public/pages/UGCModeration/utils.js